import { accessRequestPermissions } from '@infuse/api/iam/access-request';
import {
  organisationPermissionPermissions,
  organisationPermissions,
  organisationRolePermissions,
  organisationUserPermissions
} from '@infuse/api/iam/organisation';
import {
  AccessRequestDetailSlideIn,
  AccessRequestOverviewTab,
  OrganisationAccessRequestsTab
} from '@infuse/iam/access-request/pages';
import {
  OrganisationPage,
  OrganisationInfoTab,
  OrganisationPermissionsTab,
  OrganisationRoleTab,
  OrganisationsPage,
  OrganisationUsersTab
} from '@infuse/iam/organisation/pages';
import { RoleDetailSlideIn, RolePermissionsTab, RolesPage } from '@infuse/iam/role/pages';
import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';
import { tenantOrganisationPermissions } from '@infuse/api/iam/tenant';

export const OrganisationFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/organisation',
      component: InfusePageView,
      meta: {
        name: 'iam.organisations.nav.organisations',
        icon: 'cube',
        group: 'nav.nav-group.iam',
        breadcrumb: 'iam.organisations.nav.organisations',
        permissionIds: [organisationPermissions.SEARCH, tenantOrganisationPermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'organisation',
          component: OrganisationsPage
        },
        {
          path: ':id',
          components: {
            default: OrganisationPage
          },
          meta: {
            permissionIds: [organisationPermissions.GET]
          },
          children: [
            {
              path: '',
              name: 'organisation.details',
              redirect: {
                name: 'organisation.users'
              }
            },
            {
              path: 'users',
              name: 'organisation.users',
              component: OrganisationUsersTab,
              meta: {
                type: 'tab',
                label: 'iam.organisations.nav.users',
                breadcrumb: 'iam.organisations.nav.details',
                permissionIds: [organisationUserPermissions.SEARCH]
              }
            },
            {
              path: 'permissions',
              name: 'organisation.permissions',
              component: OrganisationPermissionsTab,
              meta: {
                type: 'tab',
                label: 'iam.organisations.nav.permissions',
                breadcrumb: 'iam.organisations.nav.details',
                permissionIds: [organisationPermissionPermissions.SEARCH]
              }
            },
            {
              path: 'roles',
              name: 'organisation.roles',
              component: OrganisationRoleTab,
              meta: {
                type: 'tab',
                label: 'iam.organisations.nav.roles',
                breadcrumb: 'iam.organisations.nav.details',
                permissionIds: [organisationRolePermissions.SEARCH]
              }
            },
            {
              path: 'info',
              name: 'organisation.info',
              component: OrganisationInfoTab,
              meta: {
                type: 'tab',
                label: 'iam.organisations.nav.info',
                breadcrumb: 'iam.organisations.nav.details',
                permissionIds: [organisationPermissions.GET]
              }
            },
            {
              path: 'access-requests',
              name: 'organisation.access-requests',
              component: OrganisationAccessRequestsTab,
              meta: {
                type: 'tab',
                label: 'iam.organisations.nav.access-requests',
                breadcrumb: 'iam.organisations.nav.details',
                permissionIds: [accessRequestPermissions.SEARCH]
              }
            },
            {
              path: 'access-requests/:accessRequestId',
              components: {
                default: OrganisationAccessRequestsTab,
                slideIn: AccessRequestDetailSlideIn
              },
              meta: {
                slideInParent: 'organisation.access-requests',
                permissionIds: [accessRequestPermissions.SEARCH]
              },
              children: [
                {
                  path: '',
                  redirect: { name: 'organisation.access-requests.details' }
                },
                {
                  path: 'overview',
                  name: 'organisation.access-requests.details',
                  component: AccessRequestOverviewTab,
                  meta: {
                    type: 'tab',
                    label: 'iam.access-requests.tabs.overview',
                    permissionIds: [accessRequestPermissions.GET],
                    disablePermissionRouteGuard: true
                  }
                }
              ]
            }
          ]
        },
        {
          path: ':id/roles/:roleId',
          components: {
            default: RolesPage,
            slideIn: RoleDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'organisation.role.permissions'
              }
            },
            {
              path: 'permissions',
              name: 'organisation.role.permissions',
              component: RolePermissionsTab,
              meta: {
                type: 'tab',
                label: 'tabs.common.permissions',
                permissionIds: [
                  organisationRolePermissions.SEARCH_PERMISSIONS,
                  organisationPermissionPermissions.SEARCH
                ],
                disablePermissionRouteGuard: true
              }
            }
          ]
        }
      ]
    });
  }
};
